import {
  mdiAccountSwitch,
  mdiBankOutline,
  mdiBookOpenVariant,
  mdiCalendarStar,
  mdiDatabaseImport,
  mdiDna,
  mdiHome,
  mdiHomeCity,
  mdiLightningBolt,
  mdiNewspaper,
  mdiPodcast,
  mdiSignal,
  mdiTrophyVariant,
} from '@mdi/js'
import {
  AudienceGroups,
  CognitoAttributes,
  CognitoGroups,
} from '@npm-client-frontends/client-frontends-shared-types'

export interface MenuItem {
  label: string
  link: string
  icon: string
  requiredGroups: AudienceGroups[]
  rejectedGroups: AudienceGroups[]
  description?: string
  badge?: {
    label: string
    color: 'success' | 'info'
  }
}

export const generateMenuItems = (): MenuItem[] => {
  return [
    {
      label: 'Dashboard',
      icon: mdiHome,
      link: '/main',
      description: 'Customization & Alerts',
      requiredGroups: [],
      rejectedGroups: [],
    },
    {
      label: 'Intel',
      icon: mdiNewspaper,
      link: '/list/intel',
      requiredGroups: [],
      rejectedGroups: [],
    },
    {
      label: 'Interconnection Queues',
      icon: mdiDatabaseImport,
      link: '/list/iso_queue',
      requiredGroups: [
        CognitoGroups.ContentUtilityScale,
        CognitoGroups.ContentDistributedGeneration,
      ],
      rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
    },
    {
      label: 'Interconnection Queues',
      icon: mdiDatabaseImport,
      link: '/list/ix-queues',
      requiredGroups: [
        CognitoGroups.ContentUtilityScale,
        CognitoGroups.ContentDistributedGeneration,
      ],
      badge: {
        label: 'V2',
        color: 'success',
      },
      rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
    },
    {
      label: 'Rankings',
      icon: mdiTrophyVariant,
      link: '/rankings',
      requiredGroups: [
        CognitoGroups.ContentUtilityScale,
        CognitoGroups.ContentDistributedGeneration,
      ],
      rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
    },
    {
      label: 'Signals',
      icon: mdiSignal,
      link: '/list/signals',
      requiredGroups: [
        CognitoGroups.ContentUtilityScale,
        CognitoGroups.ContentDistributedGeneration,
        CognitoGroups.ContentEurope,
        CognitoGroups.ContentDataCenters,
      ],
      rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
    },
    {
      label: 'RFP Tracker',
      icon: mdiLightningBolt,
      link: '/list/events',
      requiredGroups: [
        CognitoGroups.ContentUtilityScale,
        CognitoGroups.ContentDistributedGeneration,
        CognitoGroups.ContentDataCenters,
      ],
      rejectedGroups: [
        CognitoAttributes.FeatureIntelOnly,
        CognitoGroups.RegionEU,
      ],
    },
    {
      label: 'Project Pipeline',
      icon: mdiDna,
      link: '/list/projects',
      requiredGroups: [
        CognitoGroups.ContentUtilityScale,
        CognitoGroups.ContentDistributedGeneration,
      ],
      rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
    },
    {
      label: 'Transactions',
      icon: mdiBankOutline,
      link: '/list/transactions',
      requiredGroups: [],
      rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
    },
    {
      label: 'Company Profiles',
      icon: mdiHomeCity,
      link: '/list/org',
      requiredGroups: [],
      rejectedGroups: [],
    },
    {
      label: 'People Moves',
      icon: mdiAccountSwitch,
      link: '/list/people',
      requiredGroups: [],
      rejectedGroups: [],
    },
    {
      label: 'Training & FAQ',
      icon: mdiBookOpenVariant,
      link: '/how-to/videos',
      requiredGroups: [],
      rejectedGroups: [],
    },
  ]
}

export const ExternalMenuItems: MenuItem[] = [
  {
    label: 'NPM Events',
    icon: mdiCalendarStar,
    link: 'https://newprojectmedia.wavecast.io/npm-events',
    requiredGroups: [],
    rejectedGroups: [],
  },
  {
    label: 'NPM Podcasts',
    icon: mdiPodcast,
    link: 'https://www.buzzsprout.com/1720229',
    requiredGroups: [],
    rejectedGroups: [],
  },
]
